import React from 'react';
import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGetTicketTypes } from '@openapi/ticket-types/ticket-types';
import useNotify from '../../../hooks/useNotify';

const FilterComponent = ({
    showId,
    filterValue,
    setFilterValue,
    itemName,
    title,
    primaryName,
    secondaryName, // optional
    removeAllFromOptions = false, // optional
}) => {
    const { t } = useTranslation();
    const { notifyError } = useNotify();

    const {
        data,
        isLoading: loading,
        error,
    } = useGetTicketTypes(
        {
            page: 0,
            pageSize: 1000,
            optionalId: showId || undefined,
            onlyShowInList: true,
        },
        {
            query: {
                onError: notifyError,
            },
        },
    );

    const displayMenuItem = (item) => {
        return secondaryName ? `${item[primaryName]} (${item[secondaryName]})` : item[primaryName];
    };

    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                }}
            >
                <CircularProgress size="1.5rem" />
            </div>
        );
    }

    if (error) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                }}
            >
                <p>{`Error fetching ${itemName}`}</p>
            </div>
        );
    }

    return (
        <FormControl fullWidth>
            <InputLabel id="filter-by">{t(title)}</InputLabel>
            <Select
                fullWidth
                labelId="filter-by"
                value={filterValue}
                size="small"
                label={t(title)}
                onChange={(e) => {
                    setFilterValue(e.target.value);
                }}
            >
                {removeAllFromOptions ? null : (
                    <MenuItem value={0} key={0}>
                        {t('common.all')}
                    </MenuItem>
                )}
                {data?.[itemName]?.map((item) => (
                    <MenuItem value={item.id} key={item.id}>
                        {displayMenuItem(item)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FilterComponent;
